import React, { useEffect, useState } from 'react'
import { FaRetweet } from "react-icons/fa6";
import { FaRupeeSign } from "react-icons/fa";
import Fundmodal from './fundsModal';
import { MdSms } from "react-icons/md";
import { IoCall } from "react-icons/io5";
import { FaVrCardboard } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import ManageuserforSMS from './manageuserforSMS';
import ManageuserforVoice from './manageeuserforVOICE';
import ManageuserforRCS from './manageforRCS';
import ManageuserforWhatsapp from './manageuserforWhatsapp';
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || 'https://wa-api.globebot.io';

async function fetchUserDisplayName(userId) {
    try {
        const res = await fetch(`${API_BASE}/auth/allusersinfo/`);
        if (res.ok) {
            const users = await res.json();
            const user = users.find(u => String(u.id) === String(userId));
            if (user) {
                return user.name || user.user_name || user.username || `User#${userId}`;
            }
        }
    } catch (err) {
        console.error("Error fetching user display name:", err);
    }
    return `User#${userId}`;
}

async function fetchClientData(clientId) {
    try {
        const res = await fetch(`${API_BASE}/auth/client/${clientId}`);
        if (res.ok) return await res.json();
    } catch (err) {
        console.error("Failed to fetch client data:", err);
    }
    return null;
}

function Funds({ client_id, user_id }) {
    const [wallet, setWallet] = useState(0);
    const navigate = useNavigate();
    const currentUserId = user_id;
    const targetUserId = client_id;

    const [clientData, setClientData] = useState(null);
    const [clientDataLoading, setClientDataLoading] = useState(false);
    const [clientDataError, setClientDataError] = useState(null);

    const [funds, setFunds] = useState([]);
    const [fundsLoading, setFundsLoading] = useState(false);
    const [fundsError, setFundsError] = useState(null);
    const [userNameMap, setUserNameMap] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    const fetchWallet = async () => {
        try {
            const res = await fetch(`${API_BASE}/auth/client/${targetUserId}/meta`);
            const metaData = await res.json();
            let currentWalletValue = 0;
            if (Array.isArray(metaData?.meta) && metaData.meta.length > 0) {
                const walletMeta = metaData.meta.find(m => m.meta_key === 'wallet');
                if (walletMeta) currentWalletValue = Number(walletMeta.meta_value);
            }
            setWallet(currentWalletValue);
        } catch (err) {
            console.error('Failed to fetch wallet meta:', err);
        }
    };

    const fetchFunds = async (page = 1) => {
        setFundsLoading(true);
        setFundsError(null);
        try {
            const res = await fetch(`${API_BASE}/auth/fund?user_id=${encodeURIComponent(client_id)}`);
            if (!res.ok) throw new Error('Failed to fetch fund history');
            const data = await res.json();
            let fundRows = Array.isArray(data) ? data : (data.rows || []);
            fundRows = fundRows.filter(row => String(row.user_id) === String(client_id));
            setFunds(fundRows);

            const nameMapPatch = { ...userNameMap };
            if (!nameMapPatch[`client_${client_id}`]) {
                const cData = await fetchClientData(client_id);
                if (cData) {
                    nameMapPatch[`client_${client_id}`] = cData.name;
                    const assignerId = cData.AssignedBy;
                    if (assignerId && !nameMapPatch[`user_${assignerId}`]) {
                        const uName = await fetchUserDisplayName(assignerId);
                        nameMapPatch[`user_${assignerId}`] = uName;
                        nameMapPatch[`sender_of_client_${client_id}`] = uName;
                    } else if (assignerId === 0) {
                        nameMapPatch[`sender_of_client_${client_id}`] = "Admin";
                    }
                }
            }
            setUserNameMap(nameMapPatch);
            setTotalRecords(fundRows.length);
        } catch (err) {
            setFundsError(err.message);
        } finally {
            setFundsLoading(false);
        }
    };

    const fetchAndSetClientData = async () => {
        setClientDataLoading(true);
        setClientDataError(null);
        try {
            const data = await fetchClientData(targetUserId);
            setClientData(data);
        } catch (err) {
            setClientDataError('Failed to load client data');
        } finally {
            setClientDataLoading(false);
        }
    };

    useEffect(() => {
        fetchWallet();
        fetchAndSetClientData();
        // eslint-disable-next-line
    }, [targetUserId]);

    useEffect(() => {
        fetchFunds(currentPage);
        // eslint-disable-next-line
    }, [targetUserId, currentPage]);

    const [Open, setOpen] = useState(false);
    const [ManageUserRates, setManageUserRates] = useState(false);
    const [formData, setFormData] = useState({ creditType: "", wallet: "", remarks: "" });
    const [loading, setLoading] = useState(false);
    const [activetab, setactivetab] = useState('WHATSAPP');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // ------ INSTANT UPDATE ON FUND TRANSFER --------
    const handleSubmit = async () => {
        const { creditType, wallet: transferAmount, remarks } = formData;

        if (!creditType || !transferAmount || !remarks) {
            alert("Please fill all fields");
            return;
        }

        const numericAmount = Number(transferAmount);
        if (isNaN(numericAmount) || numericAmount === 0) {
            alert("Invalid amount");
            return;
        }

        setLoading(true);

        try {
            // Create Transaction Record
            const resFund = await fetch(`${API_BASE}/auth/fund/transfer`, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    from_user_id: currentUserId,
                    to_user_id: targetUserId,
                    amount: numericAmount,
                    remarks,
                    credit_type: creditType
                }),
            });

            if (!resFund.ok) {
                const errorData = await resFund.json();
                throw new Error(errorData.message || 'Transaction failed');
            }

            // Try to get the inserted record data from the response (if API returns).
            let newFundRow = undefined;
            try {
                const respJson = await resFund.json();
                if (respJson && respJson.id) {
                    newFundRow = respJson;
                }
            } catch(_){}

            // INSTANT UPDATE: Add to top of history locally if possible.
            setFunds(prevFunds => {
                let newFunds = prevFunds;
                if (newFundRow) {
                    // newFundRow will have at least user_id, wallet, etc.
                    newFunds = [{ ...newFundRow }, ...prevFunds];
                } else {
                    // If can't extract, force refetch for strict correctness.
                    fetchFunds(currentPage);
                    fetchWallet();
                    return prevFunds;
                }
                // Also update totalRecords
                setTotalRecords(prevRecords => prevRecords + 1);

                return newFunds;
            });

            // INSTANT UPDATE: Update wallet instantly if possible
            setWallet(prevWallet => Number(prevWallet || 0) + numericAmount);

            alert("✅ Transfer successful");

            setFormData({ creditType: "", wallet: "", remarks: "" });
            setOpen(false);

            // Refetch to confirm with server data after very short delay for consistency
            setTimeout(() => {
                fetchFunds(currentPage);
                fetchWallet();
            }, 500);

        } catch (err) {
            console.error("❌ FRONTEND ERROR:", err);
            alert("❌ Error: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    const pageCount = Math.ceil(totalRecords / pageSize);
    const recordStart = totalRecords > 0 ? (currentPage - 1) * pageSize + 1 : 0;
    const recordEnd = Math.min(currentPage * pageSize, totalRecords);

    return (
        <>
            <div className='w-[100%] flex justify-between mt-2'>
                <div className='flex gap-2'>
                    <button
                        onClick={() => setOpen(true)}
                        className='p-2 hover:bg-[#00816a] text-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold hover:text-[#fff] border-[1px] border-[#00816a]'>
                        <FaRetweet /> Transfer Funds
                    </button>
                    <button
                        onClick={() => setManageUserRates(true)}
                        className='p-2 hover:bg-[#00816a] text-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold hover:text-[#fff] border-[1px] border-[#00816a]'>
                        <FaRupeeSign /> Manage User Rates
                    </button>
                </div>
                <div className='flex gap-2'>
                    <button disabled className='p-2 bg-[#7952b3] rounded-md text-[12px] flex items-center justify-center font-semibold text-[#fff]'>
                        Wallet Balance : {wallet}
                    </button>
                    <button disabled className='p-2 bg-[#7952b3] rounded-md text-[12px] flex items-center font-semibold text-[#fff] justify-center'>
                        Oversell Wallet Balance : 0.0000
                    </button>
                </div>
            </div>

            <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] relative mt-4">
                <thead>
                    <tr className="text-left text-sm font-semibold text-gray-700">
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                            <span className='text-[11px] text-[#576071]'>User</span>
                        </th>
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                            <span className='text-[11px] text-[#576071]'>From User</span>
                        </th>
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                            <span className='text-[11px] text-[#576071]'>Credits</span>
                        </th>
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                            <span className='text-[11px] text-[#576071]'>Credit Type</span>
                        </th>
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                            <span className='text-[11px] text-[#576071]'>Transfer Date</span>
                        </th>
                        <th className="p-1 cursor-pointer border-[1px] border-[#dee2e6]">
                            <span className='text-[11px] text-[#576071]'>Remarks</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {fundsLoading ? (
                        <tr><td colSpan={6} className="p-2 text-center text-[11px] text-[#858c97]">Loading...</td></tr>
                    ) : fundsError ? (
                        <tr><td colSpan={6} className="p-2 text-center text-[11px] text-red-500">{fundsError}</td></tr>
                    ) : funds.length === 0 ? (
                        <tr><td colSpan={6} className="p-2 text-center text-[11px] text-[#858c97]">No fund records found</td></tr>
                    ) : (
                        funds.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((row) => (
                            <tr key={row.id} className="text-[12px] bg-white border-b">
                                <td className="p-1 border">{userNameMap[`client_${client_id}`] || "Loading..."}</td>
                                <td className="p-1 border font-semibold text-blue-600">{userNameMap[`sender_of_client_${client_id}`] || "System"}</td>
                                <td className="p-1 border text-green-600 font-bold">{row.wallet}</td>
                                <td className="p-1 border">{row.credit_type}</td>
                                <td className="p-1 border">{row.created_at ? new Date(row.created_at).toLocaleString() : '-'}</td>
                                <td className="p-1 border italic">{row.remarks}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            <div className="flex flex-wrap items-center justify-between mt-2 mb-2">
                <p className='text-[11px] text-[#3f7fc8]'>
                    {totalRecords > 0 ? `Showing ${recordStart} to ${recordEnd} of ${totalRecords} records` : 'Showing 0 to 0 of 0 records'}
                </p>
                {pageCount > 1 && (
                    <div className="flex gap-1">
                        <button className="px-2 py-1 bg-[#eee] border rounded text-xs" onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1}>Prev</button>
                        {[...Array(pageCount).keys()].map(i => (
                            <button key={i}
                                className={`px-2 py-1 border rounded text-xs ${currentPage === i + 1 ? "bg-[#3f7fca] text-white" : "bg-[#eee]"}`}
                                onClick={() => setCurrentPage(i + 1)}
                                disabled={currentPage === i + 1}
                            >{i + 1}</button>
                        ))}
                        <button className="px-2 py-1 bg-[#eee] border rounded text-xs" onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage === pageCount}>Next</button>
                    </div>
                )}
            </div>

            {/* Transfer Funds Modal */}
            <Fundmodal isOpen={Open} onClose={() => setOpen(false)} heading={'Fund Transfer'} width={'350px'}>
                <div className='py-1 w-[100%] dark:bg-[#121519]'>
                    <div className='w-[100%] flex flex-wrap gap-2'>
                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Credit Type</label>
                            <select name="creditType" value={formData.creditType} onChange={handleChange}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'>
                                <option value="">Select Credit Type</option>
                                <option value="Actual">Actual</option>
                            </select>
                        </div>
                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Wallet (₹)</label>
                            <input type="number" name="wallet" value={formData.wallet} onChange={handleChange}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                placeholder='Enter credits to transfer' />
                        </div>
                        <div className='w-full flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Remarks</label>
                            <input type="text" name="remarks" value={formData.remarks} onChange={handleChange}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                placeholder='Enter remarks' />
                        </div>
                    </div>
                </div>
                <div className='w-full flex items-center justify-end gap-1 mt-4'>
                    <button onClick={handleSubmit} disabled={loading}
                        className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'>
                        <span className='text-[12px] font-bold'>{loading ? "Processing..." : "Save"}</span>
                    </button>
                    <button onClick={() => setOpen(false)}
                        className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'>
                        <span className='text-[12px] font-bold'>Close</span>
                    </button>
                </div>
            </Fundmodal>

            {/* Manage User Rates Modal */}
            <Fundmodal isOpen={ManageUserRates} onClose={() => setManageUserRates(false)} heading={'Manage User Rates'} width={'800px'} style={{ maxHeight: '80vh', overflowY: 'auto' }}>
       
                <div className='py-1 w-[100%] dark:bg-[#121519] flex flex-wrap shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] mt-4'>
                    <div className='sm:w-[20%] w-[100%] sm:block flex flex-wrap border-r-[1px] border-[#e3e9ef] p-2'>
                        {[
                            // { key: 'sms',       icon: <MdSms />,         label: 'SMS'       },
                            // { key: 'VOICE',     icon: <IoCall />,        label: 'VOICE'     },
                            // { key: 'RCS',       icon: <FaVrCardboard />, label: 'RCS'       },
                            { key: 'WHATSAPP',  icon: <FaWhatsapp />,    label: 'WHATSAPP'  },
                        ].map(tab => (
                            <button key={tab.key} onClick={() => setactivetab(tab.key)}
                                className={`flex items-center text-[12px] font-semibold gap-2 ${activetab === tab.key
                                    ? 'border-b-[2px] border-[#3f7fca] text-[#3f7fca]'
                                    : 'border-b-[1px] border-transparent text-[#61748f]'
                                } px-2 py-2`}>
                                {tab.icon} {tab.label}
                            </button>
                        ))}
                    </div>
                    <div className='sm:w-[80%] w-[100%] p-2'>
                        {/* ✅ Pass client_id as user_id prop to all manage rate components */}
                        {/* {activetab === 'sms'      && <ManageuserforSMS      user_id={client_id} current_user_id = {user_id}/>}
                        {activetab === 'VOICE'    && <ManageuserforVoice    user_id={client_id} current_user_id = {user_id}/>}
                        {activetab === 'RCS'      && <ManageuserforRCS      user_id={client_id} current_user_id = {user_id}/>} */}
                        {activetab === 'WHATSAPP' && <ManageuserforWhatsapp user_id={client_id} current_user_id = {user_id}/>}
                    </div>
                </div>
            </Fundmodal>
        </>
    );
}

export default Funds;